import type { TelemetryClientId } from '@ms/yammer-telemetry-support';
import { MetaOsHubName } from '@ms/yammer-web-support/dist/metaOsHub';
import { isMobileEmbedView } from '@ms/yammer-web-support/dist/userAgent';

import { VivaEngageAppEntityId, getContext } from '../../teams/context';

type GetTelemetryClientId = () => Promise<TelemetryClientId>;
export const getTelemetryClientId: GetTelemetryClientId = async () => {
  if (isMobileEmbedView()) {
    return 'YAMMER_VIVA_CONNECTIONS';
  }

  try {
    const { appType, hubName, entityId } = await getContext();

    const isVivaEngageApp = entityId === VivaEngageAppEntityId;

    if (isVivaEngageApp) {
      if (hubName === MetaOsHubName.Outlook) {
        return 'YAMMER_VIVAENGAGE_OUTLOOK_PERSONAL_APP';
      }

      if (hubName === MetaOsHubName.Office) {
        return 'YAMMER_VIVAENGAGE_OFFICE_PERSONAL_APP';
      }

      return 'YAMMER_VIVAENGAGE_PERSONAL_APP';
    }

    if (hubName === MetaOsHubName.Outlook) {
      return 'YAMMER_METAOS_OUTLOOK_PERSONAL_APP';
    }

    if (hubName === MetaOsHubName.Office) {
      return 'YAMMER_METAOS_OFFICE_PERSONAL_APP';
    }

    if (appType === 'tab') {
      return 'YAMMER_TEAMS';
    }

    return 'YAMMER_VIVAENGAGE_PERSONAL_APP';
  } catch {
    //continue regardless of error
  }

  return 'YAMMER_VIVAENGAGE_PERSONAL_APP';
};
